import React from 'react';
import icCheckboxActiveOffMedium from 'Assets/img/ic_checkbox_active_off_24@2x.png';
import icCheckboxActiveOnMedium from 'Assets/img/ic_checkbox_active_on_24@2x.png';
import icCheckboxDisabledOffMedium from 'Assets/img/ic_checkbox_disabled_off_24@2x.png';
import icCheckboxDisabledOnMedium from 'Assets/img/ic_checkbox_disabled_on_24@2x.png';

const BasicCheckbox = ({ isChecked = false, isDisabled = false, size = 'medium', onClick, ...rest }) => {
  let img = null;
  if (isDisabled) {
    if (isChecked) {
      img = icCheckboxDisabledOnMedium;
    } else {
      img = icCheckboxDisabledOffMedium;
    }
  } else {
    if (isChecked) {
      img = icCheckboxActiveOnMedium;
    } else {
      img = icCheckboxActiveOffMedium;
    }
  }
  const imgSize = size === 'medium' ? '24px' : '20px';
  return (
    <div className='cursor-pointer no-drag' onClick={onClick} {...rest}>
      <img src={img} alt='checkbox' style={{ width: imgSize, height: imgSize }} />
    </div>
  );
};

export default BasicCheckbox;
